<template>
	<v-dialog v-model="isDialogShow" persistent max-width="460" content-class="rounded-xl">
		<v-card>
			<v-card-text class="text-center">
				<div class="pt-3 d-flex justify-center">
					<v-col cols="6">
						<v-img src="/assets/ilustration/confirm-vo.svg"></v-img>
					</v-col>
				</div>
				<template>
					<div class="pt-2 font-size-11">Anda berhasil melakukan Upgrade Jaringan</div>
					<div class="pt-2 font-size-11">Silakan Login kembali untuk memperbarui data</div>
				</template>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn depressed height="40" width="100" color="primary" class="text-capitalize rounded-xl" @click.stop="modalHide">{{ closeText }}</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data () {
		return {
			isDialogShow: false,
			closeText: 'Oke',
		}
	},
	props: {
	},
	computed: {
	},
	methods: {
		modalHide() {
			this.$emit('action')
		},
		modalShow() {
			this.isDialogShow = true
		},
	}
};
</script>